import { FATCATaxResidencyEntry } from '../utils/useFATCATaxResidencies';
import { mockReasonsForTinMissing } from './mockVariablesForValues';

export const getTINReasonOptionsFromResidencyOptions = async (
  currentTaxResidenciesWithoutReasonOptions: FATCATaxResidencyEntry[],
) => {
  await new Promise((resolve) => setTimeout(resolve, 500));

  return currentTaxResidenciesWithoutReasonOptions.map((entry) => {
    if (entry.tinAbsent && 'reasonList' in entry) {
      entry.reasonList = mockReasonsForTinMissing;

      entry.tinAbsentSelectedReason = null;
    }

    return entry;
  });
};
